export default "__VITE_ASSET__DVvkzO13__"